import { AfterViewInit, Directive, ElementRef, inject, QueryList, ViewChildren } from '@angular/core';
import { ImgPreloadDirective } from '@fgb/portal-component-library/src/lib/directives';

/**
 * Base component for the loyalty feed to load image(s) if ImgPreloadDirective is found.
 */
@Directive()
export class FeedBaseComponent implements AfterViewInit {
  hasImage: boolean = false;
  private _el: ElementRef<HTMLDivElement> = inject(ElementRef);
  @ViewChildren(ImgPreloadDirective) private imgPreload!: QueryList<ImgPreloadDirective>;

  /* ================================
   * Lifecycle Hooks
   * ================================ */
  ngAfterViewInit(): void {
    this.hasImage = this.imgPreload.length > 0;
  }

  /* ================================
   * Public Api
   * ================================ */

  /**
   * Load or show image or images if many
   */
  loadImages(): void {
    if (this.imgPreload.length === 0) return;

    this.imgPreload.forEach((imgPreload) => {
      imgPreload.load();
    });
  }

  get el(): ElementRef<HTMLDivElement> {
    return this._el;
  }
}
